<template>
    <div id="services-page">
        <div class="page-heading hide-on-small">
            <h2 class="display-4 montserrat-bold mb-0">Vouchers</h2>
            <div class="mt--2 heading-small">Shop's available vouchers for you</div>
        </div>
    
        <!-- <div class="search-bar-container">
            <i class="fas fa-search icon"></i> 
            <input type="text" placeholder="Search" class="search-bar" v-model="expertParams.search" @keyup.enter="$refs.list.refresh()">
        </div> -->

        <div class="list-container">
            <div class="list-wrapper container-fluid">
                <paginated-section v-if="fetchLink"
                    :fetch-link="fetchLink" :params="fetchParams"
                    paginate-path="data.result.vouchers"
                    ref="list"
                    simplified is-row
                    @page-changed="scrollToTop"
                >
                    <template slot="loading">
                        <div class="col-12">
                            <h3 class="text-muted m-0 pt-5 pb-5 text-center">
                                <i class="fas fa-spin fa-spinner mr-2"></i> Loading vouchers
                            </h3>
                        </div>
                    </template>
                    <template slot="empty">
                        <div class="col-12"><h3 class="text-muted m-0 pt-5 pb-5 text-center">No vouchers were found</h3></div>
                    </template>
                    <template slot="body" slot-scope="{ record }">
                        <voucher-list-item :voucher="record" />
                    </template>
                </paginated-section>
            </div>
        </div>

        <!-- <service-modal ref="serviceModal" /> -->

    </div>
</template> 
<script>
import '@styles/table.css';
import VoucherListItem from "./VoucherListItem";
import { route } from "@utils/network";

export default {
    name: "VouchersPage",

    components: { VoucherListItem },

    data: () => ({
        loading: false,
        shop: {},
        fetchLink: null,
        fetchParams: {
            shop_id: null
        },
    }),

    methods: {
        initialize(shop) {
            this.shop = shop;
            this.fetchLink = route("vouchers");
            this.fetchParams.shop_id = shop.id;

        },
        scrollToTop() {
            return window.scrollTo(0,0);
        },
    },

    mounted() {
        this.$emit("mounted");
    }
}
</script>